<template>
  <v-container fluid grid-list-md>
    <!-- Dialog para solicitar a inclusão de telefone  -->
    <v-dialog v-model="dialogNotPhoneUsers" persistent width="500">
      <v-card>
        <v-card-text>
          <div class="text-column">
            <h4>Para incluir lembrete por WhatsApp, favor solicitar que os usuários abaixo incluam o telefone:</h4>
            <br>
            <p v-for="(userText, index) in listNotPhoneUsers" :key="index" class="ma-0">{{userText}}</p>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogNotPhoneUsers = false">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIMMM Dialog para solicitar a inclusão de telefone  -->
    <!--Dialog para confirmação de exclusão-->
    <p-upgrade-dialog :upgradeDialog="upgradeDialog" @closeDialog="upgradeDialog = false" :link_src="`${basePath}images/upgrade_wpp.mp4`"></p-upgrade-dialog>
    <p-user-edit ref="userEdit" @onSave="() => {editedItem.type = 2}"></p-user-edit>
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn :disabled="task_shared" color="primary" @click="create" class="mb-4">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <v-card>
            <v-list two-line subheader :search="search">
              <v-layout>
                <v-flex xs10 lg11>
                  <v-subheader>Descrição</v-subheader>
                </v-flex>
                <v-flex xs2 lg1>
                  <v-subheader>Ações</v-subheader>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <template v-for="(item, index) in customFilter">
                <v-list-tile :key="index">
                  <v-list-tile-content>
                    <v-list-tile-title style="color: black;font-weight: bold;font-family: Arial" v-if="item.user_id > 0">{{item.user['id_text']}}</v-list-tile-title>
                    <v-list-tile-title style="color: black;font-weight: bold;font-family: Arial" v-else>Responsável da tarefa</v-list-tile-title>
                    <v-list-tile-title>{{ item.quantity+' '+translate('value.reminder_indicator').filter(a=>a.value === item.indicator)[0].text+' antes da previsão' }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ translate('value.reminder_type').filter(a=>a.value === item.type)[0].text }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <!-- // Foi removido a edição pois teria que criar a estrutura para editar, devido o campo de responsável estar com multiple -->
                  <v-list-tile-action>
                    <v-btn icon class="mx-0">
                      <v-icon color="pink" @click="dialogDelete(item)">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="index + 1000" v-if="index + 1 < customFilter.length"></v-divider>
              </template>
              <v-list-tile three-line v-if="customFilter.length === 0">
                {{emptyTable}}
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid" @keyup.native.esc="close(400)" @keyup.native.ctrl.enter="processSave()" ref="form">
            <v-container grid-list-md>
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <v-select :label="translate('table.' + entity + '.field.user_id')" :loading="loading" :disabled="loading"
                            v-model="editedItem.users_id" :items="teamUsers" @input="onChangeType(editedItem.type)" item-text="id_text" item-value="id"
                            :rules="requiredRule(translate('table.' + entity + '.field.user_id'))" multiple></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete ref="autofocus" :label="translate('table.' + entity + '.field.type')" :filter="filterAutocomplete"
                            v-model="editedItem.type" @change="onChangeType" :rules="requiredRule(translate('table.' + entity + '.field.type'))" :items="translate('value.reminder_type')"></v-autocomplete>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field :label="translate('table.' + entity + '.field.quantity')"
                                v-model="editedItem.quantity" :rules="numericRule(translate('table.' + entity + '.field.quantity'))"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete :label="translate('table.' + entity + '.field.indicator')" :filter="filterAutocomplete"
                            v-model="editedItem.indicator" :rules="requiredRule(translate('table.' + entity + '.field.indicator'))" :items="translate('value.reminder_indicator')"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="processSave()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close(400)">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import PConfirm from './../shared/PConfirm'
  import PUpgradeDialog from './../shared/PUpgradeDialog'
  import PUserEdit from './../shared/PUserEdit'

  export default {
    mixins: [crud, rules],
    components: {
      PConfirm,
      PUserEdit,
      PUpgradeDialog
    },
    data: () => ({
      entity: 'tasktemplate_reminder',
      items: [],
      teamUsers: [],
      dialogNotPhoneUsers: false,
      listNotPhoneUsers: [],
      loading: false,
      basePath: process.env.API,
      upgradeDialog: false
    }),
    name: 'Reminder',
    props: {
      tasktemplate: {
        type: Object,
        default: function () { return {} }
      },
      task_shared: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.items = this.tasktemplate['reminders'] ? this.tasktemplate['reminders'] : []
      this.editedItem = {tasktemplate_id: this.tasktemplate.id, users_id: [null], user_id: '', type: 1, quantity: 30, indicator: 1}
      this.defaultItem = {tasktemplate_id: this.tasktemplate.id, users_id: [null], user_id: '', type: 1, quantity: 30, indicator: 1}
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
    },
    methods: {
      // processSave craido para salvar registro por registro
      processSave () {
        if ((this.$refs.form && !this.$refs.form.validate())) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        // percorre cada usuário selecionado e insere o user e salva
        this.editedItem['users_id'].forEach((userId) => {
          this.editedItem['user_id'] = userId
          this.save()
        })
      },
      beforeCreate () {
        // Carrega todos os usuário que participam da tarefa para serem adicionados nas menções
        this.loading = true
        this.$http.get(`api/get_users_template/${this.tasktemplate.id}`).then((res) => {
        // Adiciona os outros items, mas deixa o proprio usuário selecionado
          this.teamUsers = res.body
          this.loading = false
        }, err => {
          this.loading = false
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível carregar os registros, reporte o erro.',
            color: 'error',
            dialog: true
          })
          console.log(err)
        })
      },
      onChangeType (val) {
        this.listNotPhoneUsers = []
        // se for wpp verifica se o plano não é gratis e verifica se os usuários elecionados possuem telefone
        if (val === 2) {
          if (this.checkIsFree()) {
            setTimeout(() => {
              this.editedItem.type = 1
            }, 100)
            this.upgradeDialog = true
            // Caso o usuário tenha sido selecionado e ele não tenha telefone mostra pra ele adicionar um telefone
          } else if (this.editedItem['users_id'].length === 1 && this.editedItem['users_id'][0] === this.$auth.user().id && !this.$auth.user().phone) {
            this.$refs.userEdit.open()
            setTimeout(() => {
              this.editedItem.type = 1
            }, 100)
          } else {
            this.editedItem['users_id'].forEach((userId) => {
              let user = this.teamUsers.find((val) => val.id === userId)
              if (user) {
                // caso não tenha phone e o id seja diferente de null, pois caso seja null é o responsável da tarefa
                if (!user['phone'] && user['id'] != null) {
                  this.listNotPhoneUsers.push(user.id_text)
                }
              }
            })
            setTimeout(() => {
              // caso tenha algum usuário que nãon possui telefone manda uma msg com a lista de nomes
              if (this.listNotPhoneUsers.length > 0) {
                this.dialogNotPhoneUsers = true
                this.editedItem.type = 1
              }
            }, 500)
          }
        }
      },
      afterAddSocketDetails (item) {
        this.$emit('itemsLength', this.items.length)
      },
      afterDeleteSocketDetails (item) {
        this.$emit('itemsLength', this.items.length)
      },
      afterDelete (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'reminders',
          responseEvent: 'deleteSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterInsert (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'reminders',
          responseEvent: 'addSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterUpdate (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'reminders',
          responseEvent: 'editSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      }
    },
    computed: {
      customFilter: function () {
        return this.items.filter((item) => {
          let itemText = (item.user_id > 0 ? item.user['id_text'] : '') + ' ' + item.quantity + ' ' + this.translate('value.reminder_indicator').filter(a => a.value === item.indicator)[0].text.toString().toLowerCase()
          return itemText.match(this.search.toLowerCase())
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TemplateReminder.vue